var _path, _path2, _circle, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.0001C1 20.4034 1.23707 19.831 1.65905 19.409C2.08103 18.9871 2.65335 18.75 3.25012 18.75H15.4008",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99993 5.25H3.25012C2.65335 5.25 2.08103 5.48707 1.65905 5.90905C1.23707 6.33103 1 6.90335 1 7.50012V21.0008C1 21.5976 1.23707 22.1699 1.65905 22.5919C2.08103 23.0139 2.65335 23.251 3.25012 23.251H15.4008V17.2497",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7498,
    cy: 7.49985,
    r: 6.74985,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9746 5.01795C12.1417 4.54309 12.4714 4.14268 12.9053 3.88762C13.3393 3.63257 13.8496 3.53933 14.3457 3.62444C14.8418 3.70954 15.2919 3.96748 15.616 4.35258C15.9402 4.73768 16.1176 5.22508 16.1169 5.72846C16.1169 7.14948 13.9854 7.85999 13.9854 7.85999V8.92258",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.042 10.6992H14.0497",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.806e5f4f8aec35accd54e11760e3ba88.svg";
export { ForwardRef as ReactComponent };